import type { SxProps, Theme } from '@mui/material';

import { Alert as MuiAlert } from '@theguarantors/tg-package-material-ui';
import { mergeSx } from '@/shared/utils/merge-sx.util';
import { type MuiSxCollection } from '@/shared/types/utility.type';

type AlertProps = {
  children: React.ReactNode;
  severity: 'info' | 'error' | 'warning' | 'success';
  iconPosition?: 'start' | 'center' | 'end';
  dataTestId?: string;
  sx?: SxProps<Theme>;
};

export function Alert({
  children,
  severity,
  iconPosition = 'center',
  dataTestId,
  sx = {},
}: AlertProps) {
  const styles = getStyles(iconPosition);

  return (
    <MuiAlert
      sx={mergeSx(styles.root, sx)}
      severity={severity}
      orientation={'horizontal'}
      data-testid={dataTestId}
    >
      {children}
    </MuiAlert>
  );
}

const getStyles = (iconPosition: 'start' | 'center' | 'end' = 'center'): MuiSxCollection => ({
  root: {
    color: 'text.secondary',
    borderRadius: '8px',
    pt: 1,
    lineHeight: '26px',
    fontSize: '16px',
    margin: '0 auto 16px',
    marginBottom: 3,
    padding: '6px 16px',
    display: 'flex',
    alignItems: iconPosition === 'center' ? 'center' : `flex-${iconPosition}`,
    '& .MuiAlert-icon': {
      alignItems: 'center',
      fontSize: 24,
      marginTop: 0,
    },
  },
});
